import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'lib-license-agreement-proceed-info-modal',
  imports: [CommonModule, TranslateModule],
  templateUrl: './license-agreement-proceed-info-modal.component.html',
  styleUrl: './license-agreement-proceed-info-modal.component.scss',
})
export class LicenseAgreementProceedInfoModalComponent {
  private readonly dialogRef = inject(DialogRef);

  public onCloseClick(): void {
    this.dialogRef.close(false);
  }
}
